import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency, unFormatPercentage } from '@/common/utils/unFormatters'
import { CompanyData } from '@/features/companies/types/companies.type'
import { UpdateFinancialSchema } from '@/features/privateCompanies/schemas/politics/updateFinancial.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateFinancial {
  company?: CompanyData
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateFinancial = ({ company, onSuccess, onError }: UseUpdateFinancial) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateFinancial'],
    mutationFn: async (data: UpdateFinancialSchema) => {
      const payload = {
        bill_integration_process: data?.company?.bill_integration_process?.value || undefined,
        fee_rule_attributes: {
          special_entries_attributes: [
            ...(company?.fee_rule?.special_entries?.map((specialEntry) => ({
              id: specialEntry?.id,
              _destroy: !Boolean(data?.company?.fee_rule?.special_entries?.some((formEntry) => specialEntry?.id === formEntry?.id)),
            })) || []),
            ...data?.company?.fee_rule?.special_entries?.filter((formEntry) => !formEntry?.id)?.map((formEntry) => ({
              fee_template_id: formEntry?.fee_template?.id,
              value: formEntry?.fee_template?.calculate_as === 'fixed'
                ? unFormatCurrency(formEntry?.value || '')
                : unFormatPercentage(formEntry?.value || ''),
              target_id: formEntry?.target?.value === 'all' || !formEntry?.target?.value ? null : formEntry?.target?.value,
              target_type: 'Establishment::Company',
            })) || [],
          ],
        }
      }

      await privateAxios.put(`/client/companies/${company?.id}/fee_rule`, {
        company: payload,
      })
    },
    onSuccess,
    onError,
  })
}
